// NOTE: Care should be taken when importing anything from this file.  Importing `* as analytics` is a bad idea
// because it can name clash (shadow) the globally available `analytics` object that segment creates.  Such
// shadowing is likely harmless as you should never be calling segments `analytics` directly anywhere in the code
// (rather you should always go through this abstraction layer) but it still should be avoided.
import { isFeatureEnabled } from '@separate/utilities/features';
import { getUtmTags } from "@separate/utilities/utmTagsStore";

export const PODERSALUD_LANDING = 'podersalud_landing';
export const PODERSALUD_SIGN_UP_CLICKED = 'podersalud_sign_up_clicked';
export const PODERSALUD_BENEFITS_SELECTED = 'podersalud_benefits_selected';
export const PODERSALUD_PERSONAL_INFO_LANDS = 'podersalud_personal_information_lands';
export const PODERSALUD_PERSONAL_INFO_INPUTTED =
  'podersalud_personal_info_inputted';
export const PODERSALUD_PERSONAL_INFO_SUBMITTED = 'podersalud_personal_information_submitted';
export const PODERSALUD_ADDRESS_INPUTTED = 'podersalud_address_inputted';
export const PODERSALUD_ADDRESS_CONFIRMATION_LANDS = 'podersalud_address_confirmation_lands';
export const PODERSALUD_ADDRESS_CONFIRMATION_SUBMITTED = 'podersalud_address_confirmation_submitted';
export const PODERSALUD_PAYMENT_LANDS = 'podersalud_payment_lands';
export const PODERSALUD_PAYMENT_SUBMITTED = 'podersalud_payment_submitted';
export const PODERSALUD_PAYMENT_SUCCESSFUL = 'podersalud_payment_successful';
export const PRODUCT_INTEREST = 'product_interest';
export const SSO_SUCCESSFUL = 'sso_successful';

export const PODERSALUD_PRODUCT_ID = 10;
export const PODERCARD_PRODUCT_ID = 6;
export const PANELIST_PRODUCT_ID = 4;

export function logEvent(eventName, properties = {}) {
  if (isFeatureEnabled('console_log_segment_events')) {
    console.log("Segment enabled?", !!window.analytics);
    console.log("Logging analytics event", eventName);
    console.log("Logging analytics data", properties);
  }
  window.analytics?.track(eventName, properties);
}

export function logProductInterest(productID) {
  const utmTags = getUtmTags();

  let properties = { ...utmTags };
  properties.productId = productID;
  logEvent(PRODUCT_INTEREST, properties);
}

export function setAnalyticsPid(pid) {
  window.analytics?.identify(pid);
}

export function setAnalyticsUser(user) {
  if (!user) return;

  if (isFeatureEnabled('console_log_segment_events')) {
    console.log("Setting analytics user pid", user.pid);
  }
  window.analytics?.identify(user.pid);
}

export function logoutAnalyticsUser() {
  window.analytics?.reset();
}
